import { l } from 'src/utils/helper';

const inputMessages = 'inputMessages';

export default {
  set(activityId, text) {
    const currentList = localStorage.getItem(inputMessages);
    let updList = {};
    try {
      updList = currentList ? JSON.parse(currentList) : {};
    } catch (err) {
      l.error(`Input message setting error. Activity Id: ${activityId}`);
      l.error(err);
    }
    updList[activityId] = text;
    localStorage.setItem(inputMessages, JSON.stringify(updList));
  },
  get(activityId) {
    const inputList = JSON.parse(localStorage.getItem(inputMessages));
    return inputList ? inputList[activityId] : null;
  },
  remove(activityId) {
    const currentList = localStorage.getItem(inputMessages);
    let updList = {};
    try {
      updList = currentList ? JSON.parse(currentList) : {};
    } catch (err) {
      l.error(`Input message remove error. Activity Id: ${activityId}`);
      l.error(err);
    }
    if (updList[activityId]) {
      delete updList[activityId];
    }
    localStorage.setItem(inputMessages, JSON.stringify(updList));
  },
  clear() {
    localStorage.removeItem(inputMessages);
  },
};
